"use strict";

exports.__esModule = true;
exports.resolveQuestionConditions = exports.removedParentRatingsForcedConditionsCleanup = exports.removedParentChoiceForcedConditionsCleanup = exports.removeLinkedQuestionConditions = exports.removeConditionFromQuestions = exports.getLinkedQuestionConditions = exports.getChildQuestions = exports.createCondition = exports.addConditionToQuestions = void 0;

var _lodash = require("lodash");

var createCondition = function createCondition(questionId, value) {
  return {
    questionId: questionId,
    value: value
  };
};

exports.createCondition = createCondition;

var addConditionToQuestions = function addConditionToQuestions(questions, receivingId, condition) {
  var receivingQuestion = [].concat(questions.filter(function (x) {
    return x.id === receivingId;
  }))[0];
  if (receivingQuestion.conditions.filter(function (x) {
    return x.questionId === condition.questionId && x.value === condition.value;
  }).length > 0) return questions;
  var newConditions = [].concat(receivingQuestion.conditions, [condition]);
  receivingQuestion = Object.assign({}, receivingQuestion, {
    conditions: newConditions
  });
  return [].concat(questions.filter(function (x) {
    return x.id !== receivingId;
  }), [receivingQuestion]);
};

exports.addConditionToQuestions = addConditionToQuestions;

var removeConditionFromQuestions = function removeConditionFromQuestions(questions, questionId, conditionToRemove) {
  var updatedQuestion = [].concat(questions.filter(function (x) {
    return x.id === questionId;
  }))[0];
  if (!updatedQuestion || !updatedQuestion.conditions) return questions;
  var newConditions = updatedQuestion.conditions.filter(function (x) {
    return x.value !== conditionToRemove.value;
  });
  updatedQuestion = Object.assign({}, updatedQuestion, {
    conditions: newConditions
  });
  return [].concat(questions.filter(function (x) {
    return x.id !== questionId;
  }), [updatedQuestion]);
};

exports.removeConditionFromQuestions = removeConditionFromQuestions;

var resolveQuestionConditions = function resolveQuestionConditions(values, conditions) {
  if (conditions.length === 0) return true;
  var resolvedValues = [];
  values.map(function (x) {
    if (Array.isArray(x.value)) {
      x.value.forEach(function (v) {
        resolvedValues.push({
          questionId: x.questionId,
          value: v
        });
      });
    }

    resolvedValues.push({
      questionId: x.questionId,
      value: x.value
    });
  });
  return (0, _lodash.intersectionWith)(resolvedValues, conditions, _lodash.isEqual).length > 0;
};

exports.resolveQuestionConditions = resolveQuestionConditions;

var getLinkedQuestionConditions = function getLinkedQuestionConditions(questions, id) {
  var matches = questions.filter(function (x) {
    return x.conditions.filter(function (y) {
      return y.questionId === id;
    }).length > 0;
  });
  if (matches.length === 0) return null;
  var conditions = [];
  matches.map(function (x) {
    return x.conditions.map(function (y) {
      return conditions.push(Object.assign({}, y, {
        question: x
      }));
    });
  });
  return conditions;
};

exports.getLinkedQuestionConditions = getLinkedQuestionConditions;

var removeLinkedQuestionConditions = function removeLinkedQuestionConditions(questions, id) {
  var linkedConditions = getLinkedQuestionConditions(questions, id);
  if (!linkedConditions || linkedConditions.length === 0) return questions;
  var questionsToUpdate = (0, _lodash.uniq)(linkedConditions.map(function (x) {
    return x.question;
  }));
  var updatedQuestions = [];
  questionsToUpdate.forEach(function (x) {
    updatedQuestions.push(Object.assign({}, x, {
      conditions: x.conditions.filter(function (y) {
        return y.questionId !== id;
      })
    }));
  });
  return [].concat(questions.filter(function (x) {
    return !questionsToUpdate.map(function (y) {
      return y.id;
    }).includes(x.id);
  }), updatedQuestions);
};

exports.removeLinkedQuestionConditions = removeLinkedQuestionConditions;

var getChildQuestions = function getChildQuestions(questions, questionId) {
  var matches = questions.filter(function (x) {
    return x.conditions.filter(function (y) {
      return y.questionId === questionId;
    }).length > 0;
  });
  return matches;
};

exports.getChildQuestions = getChildQuestions;

var removedParentChoiceForcedConditionsCleanup = function removedParentChoiceForcedConditionsCleanup(questions, value) {
  return questions.map(function (question) {
    return Object.assign({}, question, {
      conditions: question.conditions.filter(function (condition) {
        return condition.value !== value;
      })
    });
  });
};

exports.removedParentChoiceForcedConditionsCleanup = removedParentChoiceForcedConditionsCleanup;

var removedParentRatingsForcedConditionsCleanup = function removedParentRatingsForcedConditionsCleanup(questions, questionId, values) {
  return questions.map(function (question) {
    return Object.assign({}, question, {
      conditions: question.conditions.filter(function (condition) {
        return condition.questionId !== questionId || condition.questionId === questionId && !values.includes(condition.value);
      })
    });
  });
};

exports.removedParentRatingsForcedConditionsCleanup = removedParentRatingsForcedConditionsCleanup;